import { RepositoryService } from './../../../core/repositories/repository.service';
import { AuthenticationService } from './../../../core/auth/authentication.service';
import { ACCESO_EXTERNAL, PETICIONES, STORAGE } from './../../../core/utils/constants';
import { Utils } from './../../../core/utils/utils';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TokenValid } from 'src/app/core/auth/tokenvalid.model';
import { DataExternal } from 'src/app/core/entities/dataexternal.model';
import { DialogsTercerComponent } from 'src/app/shared/components/dialogs/dialogs-tercer/dialogs-tercer.component';
import { DialogsRepresentantComponent } from 'src/app/shared/components/dialogs/dialogs-representant/dialogs-representant.component';
import { DialogsRepresentantAocComponent } from 'src/app/shared/components/dialogs/dialogs-representant-aoc/dialogs-representant-aoc.component';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { ValidService } from './valid.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-valid',
  templateUrl: './valid.component.html',
  styleUrls: ['./valid.component.scss']
})
export class ValidComponent implements OnInit {

  nif: string = "";
  id: string = "";
  token: string = "";
  carpeta: string = "";
  dboid: string = "";

  loading: boolean = true;

  validToken: TokenValid = new TokenValid();
  objetoexternal: DataExternal = new DataExternal();

  constructor(private route: ActivatedRoute,
    private router: Router,
    private repository: RepositoryService,
    private validService: ValidService,
    private authService: AuthenticationService,
    private translateService: TranslateService,
    private dialog: MatDialog) {
  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {

        this.nif = params.nif;
        this.id = params.id;
        this.token = params.token;
        this.carpeta = params.carpeta;
        if(this.validate()) {
          console.log("Validado");
          this.login();
        }else{
          console.log("No Validado");
          this.router.navigate(['/external/error'], { queryParams: { numError: '1' }, queryParamsHandling: 'merge' });
        }
    });
  }

  /**
  * @description
  * Realizamos el login en parte externa segun rol y identificación expedida
  */
  private login() {
    this.authService.cleanValid();
    localStorage.setItem(STORAGE.ACCESS_TOKEN, this.token);
      const tokenEncoded = encodeURIComponent(this.token);
      this.repository.doGet(PETICIONES.valid.token + '?id=' + tokenEncoded).subscribe(json => {
        if (Utils.noUndfAndNull(json) && Utils.noUndfAndNull(json.validToken) && Utils.noUndfAndNull(json.validToken.status)) {
            if (json.validToken.status.toUpperCase() == 'OK') {

              json.validToken.token = this.token; 
              //json.validToken.certificateType = Utils.obtenerTipoCertificado(this.validToken.getCompanyid(), this.validToken.getCertificateType());
              //json.validToken.certificateType = Utils.obtenerTipoCertificadoValido(this.validToken.getCertificateType());
              this.authService.saveUserValid(json.validToken, json.accessToken, json.refreshToken);

              Object.assign(this.validToken, _.cloneDeep(json.validToken));
              console.log("tipo certificado sin depurar: " + this.validToken.getCertificateType());
              this.validToken.certificateType = Utils.obtenerTipoCertificadoValido(this.validToken.getCertificateType());

              console.log("tipo certificado depurado: " + this.validToken.getCertificateType());
              json.validToken.certificateType = this.validToken.getCertificateType();
              this.authService.saveUserValid(json.validToken, json.accessToken, json.refreshToken);

              if(this.validToken.certificateType === 'J'){
                this.nif = _.cloneDeep(this.validToken.companyId);
              }

              this.nif = this.nif.toLocaleUpperCase();
              
              this.validService.init(this.nif, this.carpeta).subscribe(result => {
                if(this.validService.rolexterno.enable){
                  switch(this.validService.rolexterno.code) {
                    case "FI4INTERNET": {
                      this.router.navigate(['/external/passarela/acces']);
                      break;
                    }
                    case "FI4EMPRESA": {
                      this.router.navigate(['/external/empreses/acces']);
                      break;
                    }
                    case "FI4PROVEIDOR": {
                      this.router.navigate(['/external/proveidors/acces']);
                      break;
                    }
                  }
                }else{
                  if(this.validService.allPersons != null){
                  switch(this.carpeta) {
                    case "1": {
                      if(this.validService.allrepresentanteAOC != null && this.validService.allrepresentanteAOC.length > 0){
                        if(this.validService.allPersons.length > 1){
                          this.validService.errorCargaWS("WARNINGS.error_tercer_duplicado");
                          this.router.navigate(['/external/passarela/acces']);
                        }else{
                          this.dialogoRepresentantsAOC(this.validService.allrepresentanteAOC);
                        }
                      }else{
                        if(this.validService.isCif){
                          this.errorvalidCiudadano();
                          this.router.navigate(['/external/passarela/acces']);
                        }else{
                          if(this.validService.allPersons == null){
                            this.errorBuscaCiudadano();
                            this.router.navigate(['/external/passarela/acces']);
                          }else{
                            if(this.validService.allPersons.length > 1){
                              this.validService.errorCargaWS("WARNINGS.error_tercer_duplicado");
                              this.router.navigate(['/external/passarela/acces']);
                            }else{
                              this.objetoexternal.dboid = _.cloneDeep(this.validService.allPersons[0].dboid);
                              this.objetoexternal.tercer = _.cloneDeep(this.validService.allPersons);
                              this.objetoexternal.representant = null;
                              this.objetoexternal.representants = [];
                              this.objetoexternal.representantAOC = null;
                              this.objetoexternal.representantsAOC = [];
                              this.router.navigate([this.getNomCarpeta()], {state: {dataexternal: this.objetoexternal}});
                            }
                          }
                        }
                      }
                      break;
                    }
                    case "2": {
                      if(this.validService.allrepresentanteAOC != null && this.validService.allrepresentanteAOC.length > 0){
                        this.dialogoRepresentantsAOC(this.validService.allrepresentanteAOC);
                      }else{
                        if(this.validService.isCif || this.validToken.certificateType === 'J'){
                          if(this.validService.allPersons == null){
                            this.errorBuscaEmpresa();
                            this.router.navigate(['/external/empreses/acces']);
                          }else{
                            if(this.validService.allPersons.length > 1){
                              this.dialogoTercer(this.validService.allPersons);
                            }else{
                              this.objetoexternal.dboid = _.cloneDeep(this.validService.allPersons[0].dboid);
                              this.objetoexternal.tercer = _.cloneDeep(this.validService.allPersons);
                              this.objetoexternal.representant = null;
                              this.objetoexternal.representants = [];
                              this.objetoexternal.representantAOC = null;
                              this.objetoexternal.representantsAOC = [];
                              this.router.navigate([this.getNomCarpeta()], {state: {dataexternal: this.objetoexternal}});
                            }
                          }
                        }else{
                          if(this.validService.isLicencias){
                            if(this.validService.allPersons == null){
                              this.errorBuscaEmpresa();
                              this.router.navigate(['/external/empreses/acces']);
                            }else{
                              if(this.validService.allPersons.length > 1){
                                this.dialogoTercer(this.validService.allPersons);
                              }else{
                                this.objetoexternal.dboid = _.cloneDeep(this.validService.allPersons[0].dboid);
                                this.objetoexternal.tercer = _.cloneDeep(this.validService.allPersons);
                                this.objetoexternal.representant = null;
                                this.objetoexternal.representants = [];
                                this.objetoexternal.representantAOC = null;
                                this.objetoexternal.representantsAOC = [];
                                this.router.navigate([this.getNomCarpeta()], {state: {dataexternal: this.objetoexternal}});
                              }
                            }
                          }else{
                            if(this.validService.allRepresentants != null){
                              if(this.validService.allRepresentants.length > 1){
                                this.dialogoRepresentants(this.validService.allRepresentants);
                              }else{
                                if(this.validService.allRepresentants.length === 1){
                                  this.objetoexternal.dboid = _.cloneDeep(this.validService.allPersons[0].dboid);
                                  //this.objetoexternal.tercer = null;
                                  this.objetoexternal.tercer = _.cloneDeep(this.validService.allPersons);
                                  this.objetoexternal.representant = this.validService.allRepresentants[0].entitatcodi;
                                  this.objetoexternal.representants = this.validService.allRepresentants;
                                  this.objetoexternal.representantAOC = null;
                                  this.objetoexternal.representantsAOC = [];
                                  this.router.navigate([this.getNomCarpeta()], {state: {dataexternal: this.objetoexternal}});
                                }else{
                                  this.errorvalidEmpresa();
                                  this.router.navigate(['/external/empreses/acces']);
                                }
                              }
                            }else{
                              if(this.validService.allPersons == null){
                                this.errorBuscaCiudadano();
                              }else{
                                this.errorvalidEmpresa();
                              }
                              this.router.navigate(['/external/empreses/acces']);
                            }
                          }
                        }
                      }
                      break;
                    }
                    case "3": {
                      if(this.validService.allrepresentanteAOC != null && this.validService.allrepresentanteAOC.length > 0){
                        this.dialogoRepresentantsAOC(this.validService.allrepresentanteAOC);
                      }else{
                        if(this.validService.isProveidor.isproveedor){
                          if(this.validService.allPersons.length > 1){
                            this.dialogoTercer(this.validService.allPersons);
                          }else{
                            this.objetoexternal.dboid = _.cloneDeep(this.validService.allPersons[0].dboid);
                            this.objetoexternal.tercer = this.validService.allPersons;
                            this.objetoexternal.representant = null;
                            this.objetoexternal.representants = [];
                            this.objetoexternal.representantAOC = null;
                            this.objetoexternal.representantsAOC = [];
                            this.router.navigate([this.getNomCarpeta()], {state: {dataexternal: this.objetoexternal}});
                          }
                        }else{
                          if(this.validService.isProveidor.error != null){
                            let texto1 = this.translateService.instant('WARNINGS.error_ws_provee');
                            let texto2 = this.translateService.instant('WARNINGS.error_ws_provee_link');
                            this.errorBuscaProveedor(texto1, texto2);
                          }else{
                            let texto1 = this.translateService.instant('WARNINGS.error_buscador_prov');
                            let texto2 = this.translateService.instant('WARNINGS.error_cif_prov');
                            this.errorBuscaProveedor(texto1, texto2);
                          }
                          this.router.navigate(['/external/proveidors/acces']);
                        }
                      }
                      break;
                    }
                  }
                }else{
                  this.router.navigate(['/external/error'], { queryParams: { numError: '3' }, queryParamsHandling: 'merge' });
                }
                }
              });
            } else {
              this.router.navigate(['/external/error'], { queryParams: { numError: '3' }, queryParamsHandling: 'merge' });
            }
        } else {
          this.router.navigate(['/external/error'], { queryParams: { numError: '2' }, queryParamsHandling: 'merge' });
        }
      }, err => {
        this.router.navigate(['/external/error'], { queryParams: { numError: '4' }, queryParamsHandling: 'merge' });
      });
  }

  /**
  * @description
  * Validamos si los parámetros son correctos.
  * Debe haber carpeta (del 1 al 3) e id
  */
  private validate(): boolean {
    if (Utils.noUndfAndNull(this.carpeta) && Utils.noUndfAndNull(this.id)) {
      for (const object of Object.values(ACCESO_EXTERNAL)) {
        if (object.type == Number(this.carpeta)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
  * @description
  * Devuelve la URL home de carpeta según el rol con el que entres
  */
  private getNomCarpeta(): string | undefined {
    const found = Object.values(ACCESO_EXTERNAL).find(object => object.type === Number(this.carpeta));
    return found?.urlHome;
  }

  /**
  * @description
  * Abre el dialog si hay terceras personas
  * @param dboid datos terceras personas
  */
  public dialogoTercer(dboid: any){

    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '80%' : anchodisp = "50%";

    const dialogRef = this.dialog.open(DialogsTercerComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { personsByIdNumCtrlDig: dboid }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        this.objetoexternal.dboid = _.cloneDeep(result);
        this.objetoexternal.tercer = _.cloneDeep(this.validService.allPersons);
        this.objetoexternal.representant = null;
        this.objetoexternal.representants = [];
        this.objetoexternal.representantAOC = null;
        this.objetoexternal.representantsAOC = [];
        this.router.navigate([this.getNomCarpeta()], {state: {dataexternal: this.objetoexternal}});
      }else{
        this.router.navigate(["/external/passarela/acces"]);
      }
    });
  }

  /**
  * @description
  * Abre el dialog si la persona es representante
  * @param dboid datos representante
  */
  public dialogoRepresentants(representant: any){
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '80%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(DialogsRepresentantComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { representant : representant }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        console.log(result);
        this.objetoexternal.dboid = _.cloneDeep(this.validService.allPersons[0].dboid);
        this.objetoexternal.tercer = _.cloneDeep(this.validService.allPersons);
        this.objetoexternal.representant = result;
        this.objetoexternal.representants = _.cloneDeep(this.validService.allRepresentants);
        this.objetoexternal.representantAOC = null;
        this.objetoexternal.representantsAOC = [];
        this.router.navigate([this.getNomCarpeta()], {state: {dataexternal: this.objetoexternal}});
      }else{
        this.router.navigate(["/external/empreses/acces"]);
      }
    });
  }

  /**
  * @description
  * Abre el dialog si la persona es representante
  * @param dboid datos representante
  */
  public dialogoRepresentantsAOC(representantaoc: any){
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '80%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(DialogsRepresentantAocComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true, 
      data: { representant : representantaoc , llamada: 1, carpeta: this.carpeta, dni: this.nif}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result == undefined){
        switch(this.carpeta) {
          case "1": {
            this.router.navigate(["/external/passarela/acces"]);
            break;
          }
          case "2": {
            this.router.navigate(['/external/empreses/acces']);
            break;
          }
          case "3": {
            this.router.navigate(['/external/proveidors/acces']);
            break;
          }
        }
      }else{
        console.log(this.carpeta);
        this.objetoexternal.dboid = _.cloneDeep(this.validService.allPersons[0].dboid);
        this.objetoexternal.tercer = _.cloneDeep(this.validService.allPersons);
        this.objetoexternal.representant = null;
        this.objetoexternal.representants = [];
        this.objetoexternal.representantAOC = result;

        /*PRUEBASSSS*/
        if(result.representantsAOC != null && result.representantsAOC.length > 0){
          this.objetoexternal.representantsAOC = _.cloneDeep(result.representantsAOC);
        }else{
          this.objetoexternal.representantsAOC = this.validService.allrepresentanteAOC;
        }
        
        this.router.navigate([this.getNomCarpeta()], {state: {dataexternal: this.objetoexternal}});
      }
    });
  }

  
  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorvalidEmpresa() {
      let texto1 = this.translateService.instant('WARNINGS.error_valid_empresa');
      let texto2 = this.translateService.instant('WARNINGS.error_cif_empr');
      let niftexto = texto1 + this.nif.bold() + texto2;
      setTimeout(() => {
          const dialogRef = this.dialog.open(DialogsAlertComponent, {
              disableClose: true,
              hasBackdrop: true,
              data: { texto: niftexto }
          });
          dialogRef.afterClosed().subscribe(result => {
              console.log(result);
          });
      }, 500);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorBuscaEmpresa() {
    let texto1 = this.translateService.instant('WARNINGS.error_buscador_emp');
    let texto2 = this.translateService.instant('WARNINGS.error_tercer_emp');
    let niftexto = texto1 + this.nif.bold() + texto2;
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorvalidCiudadano() {
    let texto1 = this.translateService.instant('WARNINGS.error_valid_ciutada');
    let texto2 = this.translateService.instant('WARNINGS.error_cif_ciut');
    let niftexto = texto1 + this.nif.bold() + texto2;
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorBuscaCiudadano() {
    let texto1 = this.translateService.instant('WARNINGS.error_buscador_ciu');
    let texto2 = this.translateService.instant('WARNINGS.error_tercer_ciu');
    let niftexto = texto1 + this.nif.bold() + texto2;
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error en carpeta empresa
  */
  public errorBuscaProveedor(texto1: string, texto2: string) {
    let niftexto = texto1 + this.nif.bold() + texto2;
    setTimeout(() => {
        const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: niftexto }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }, 500);
  }

}
